import script from "./Salary.vue?vue&type=script&setup=true&lang=js"
export * from "./Salary.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__